/**
 * The page's one column: the header, search, source chips, landing and the
 * library chat all line up on it.
 */
export const RESEARCH_COLUMN = "mx-auto w-full max-w-4xl px-8";
